import React from "react";
import { RISK_STATUSES, resolveRisk, RISK_BY_KEY } from "../lib/risk";

/**
 * Segmented Red / Amber / Green risk picker.
 * Mirrors the ClassSelect styling so the Edit/New project modals feel
 * consistent.
 */
export default function RiskSelect({ value, onChange, testId }) {
  const active = resolveRisk(value);
  return (
    <div
      className="grid grid-cols-3 gap-1.5"
      role="radiogroup"
      aria-label="Project risk rating"
      data-testid={testId || "risk-select"}
    >
      {RISK_STATUSES.map((r) => {
        const isActive = active === r.key;
        return (
          <button
            key={r.key}
            type="button"
            onClick={() => onChange(r.key)}
            aria-pressed={isActive}
            className={`px-2.5 py-1.5 rounded border-2 text-left transition-all ${
              isActive
                ? "shadow-sm"
                : "bg-white border-[var(--line)] hover:border-[var(--accent)]"
            }`}
            style={isActive ? { borderColor: r.tone, background: `${r.tone}12` } : undefined}
            data-testid={`${testId || "risk-select"}-${r.key}`}
          >
            <div className="flex items-center gap-2">
              <span
                style={{
                  width: 10,
                  height: 10,
                  background: r.tone,
                  borderRadius: "50%",
                  display: "inline-block",
                  flexShrink: 0,
                }}
              />
              <div className="min-w-0">
                <div
                  className="text-[10px] uppercase tracking-[0.14em] font-semibold"
                  style={{ color: r.tone }}
                >
                  {r.label}
                </div>
                <div className="text-[10px] muted leading-tight truncate">{r.sub}</div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
